// extracted by mini-css-extract-plugin
export default {"container":"Contato_container__TfblK","info":"Contato_info__vImAQ","imagem":"Contato_imagem__mI3XF","lista":"Contato_lista__VV0cd","itens":"Contato_itens__nacXP"};